// Lead push API keys: generated in the browser, only the SHA-256 hash is sent to the database.
// The leads edge function hashes the key it receives the same way to authenticate a call.

const KEY_PREFIX = "opk_";
const RANDOM_BYTES = 24;
const VISIBLE_PREFIX_LENGTH = KEY_PREFIX.length + 6;

const toBase64Url = (bytes: Uint8Array) =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

export const generateLeadApiKey = (): string =>
  KEY_PREFIX +
  toBase64Url(crypto.getRandomValues(new Uint8Array(RANDOM_BYTES)));

export const hashLeadApiKey = async (key: string): Promise<string> => {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(key),
  );
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
};

/** Start of the key, kept to recognize it in Settings without exposing it. */
export const getLeadApiKeyPrefix = (key: string): string =>
  key.slice(0, VISIBLE_PREFIX_LENGTH);
